import {FC} from 'react';
import {Box, Flex} from '@chakra-ui/react';
import {useShallow} from 'zustand/react/shallow';
import {hasValue, useT} from '@kcast-fe/core';
import {useMessagesStore} from 'stores';
import {Svg} from 'ui-kit';

const ListFooterFC: FC = () => {
  const {isThinking, thinkingStatus, filter} = useMessagesStore(useShallow((state) => state));

  const {t} = useT();

  return (
    <Box h={filter ? '360px' : '320px'} transition={'height var(--tr-150-eo)'}>
      <Flex
        gap={'8px'}
        alignItems={'center'}
        p={{base: '48px 70px 16px 70px', smToMd: '16px 24px'}}
        data-testid={'ai-status'}
      >
        {isThinking && (
          <>
            <Svg name={'LogoAnimated'} />
            <Box>{hasValue(thinkingStatus) ? thinkingStatus : t('labels.thinking')}</Box>
          </>
        )}
      </Flex>
    </Box>
  );
};

export const ListFooter = ListFooterFC;
